export const rotoWireDailyMatchupsMockResp = {
    "isError": false,
    "errorMessage": null,
    "data": {
        "matchups": [
            {
                "away": {
                    "teamNickname": "Knicks",
                    "projectedPlayers": [
                        "Jalen Brunson",
                        "Mikal Bridges",
                        "Josh Hart",
                        "OG Anunoby",
                        "Karl-Anthony Towns"
                    ]
                },
                "home": {
                    "teamNickname": "Cavaliers",
                    "projectedPlayers": [
                        "Darius Garland",
                        "Donovan Mitchell",
                        "Max Strus",
                        "Evan Mobley",
                        "Jarrett Allen"
                    ]
                }
            },
            {
                "away": {
                    "teamNickname": "Grizzlies",
                    "projectedPlayers": [
                        "Ja Morant",
                        "Desmond Bane",
                        "Jaylen Wells",
                        "Jaren Jackson",
                        "Zach Edey"
                    ]
                },
                "home": {
                    "teamNickname": "Magic",
                    "projectedPlayers": [
                        "Cole Anthony",
                        "Kentavious Caldwell-Pope",
                        "Franz Wagner",
                        "Paolo Banchero",
                        "Goga Bitadze"
                    ]
                }
            },
            {
                "away": {
                    "teamNickname": "Bucks",
                    "projectedPlayers": [
                        "Damian Lillard",
                        "Andre Jackson",
                        "Taurean Prince",
                        "Giannis Antetokounmpo",
                        "Brook Lopez"
                    ]
                },
                "home": {
                    "teamNickname": "Wizards",
                    "projectedPlayers": [
                        "Jordan Poole",
                        "Bilal Coulibaly",
                        "Khris Middleton",
                        "Kyshawn George",
                        "Alex Sarr"
                    ]
                }
            },
            {
                "away": {
                    "teamNickname": "Heat",
                    "projectedPlayers": [
                        "Tyler Herro",
                        "Duncan Robinson",
                        "Andrew Wiggins",
                        "Bam Adebayo",
                        "Kel'el Ware"
                    ]
                },
                "home": {
                    "teamNickname": "Raptors",
                    "projectedPlayers": [
                        "Immanuel Quickley",
                        "Gradey Dick",
                        "RJ Barrett",
                        "Scottie Barnes",
                        "Jonathan Mogbo"
                    ]
                }
            },
            {
                "away": {
                    "teamNickname": "Pelicans",
                    "projectedPlayers": [
                        "Jose Alvarado",
                        "CJ McCollum",
                        "Trey Murphy",
                        "Zion Williamson",
                        "Yves Missi"
                    ]
                },
                "home": {
                    "teamNickname": "Mavericks",
                    "projectedPlayers": [
                        "Kyrie Irving",
                        "Max Christie",
                        "Klay Thompson",
                        "Kessler Edwards",
                        "P.J. Washington"
                    ]
                }
            },
            {
                "away": {
                    "teamNickname": "Pistons",
                    "projectedPlayers": [
                        "Cade Cunningham",
                        "Tim Hardaway",
                        "Ausar Thompson",
                        "Tobias Harris",
                        "Jalen Duren"
                    ]
                },
                "home": {
                    "teamNickname": "Spurs",
                    "projectedPlayers": [
                        "Chris Paul",
                        "De'Aaron Fox",
                        "Devin Vassell",
                        "Harrison Barnes",
                        "Jeremy Sochan"
                    ]
                }
            },
            {
                "away": {
                    "teamNickname": "Timberwolves",
                    "projectedPlayers": [
                        "Mike Conley",
                        "Anthony Edwards",
                        "Jaden McDaniels",
                        "Naz Reid",
                        "Rudy Gobert"
                    ]
                },
                "home": {
                    "teamNickname": "Rockets",
                    "projectedPlayers": [
                        "Aaron Holiday",
                        "Jalen Green",
                        "Amen Thompson",
                        "Dillon Brooks",
                        "Alperen Sengun"
                    ]
                }
            },
            {
                "away": {
                    "teamNickname": "Thunder",
                    "projectedPlayers": [
                        "Shai Gilgeous-Alexander",
                        "Luguentz Dort",
                        "Jalen Williams",
                        "Chet Holmgren",
                        "Isaiah Hartenstein"
                    ]
                },
                "home": {
                    "teamNickname": "Jazz",
                    "projectedPlayers": [
                        "Isaiah Collier",
                        "Jordan Clarkson",
                        "Lauri Markkanen",
                        "John Collins",
                        "Walker Kessler"
                    ]
                }
            },
            {
                "away": {
                    "teamNickname": "Warriors",
                    "projectedPlayers": [
                        "Stephen Curry",
                        "Brandin Podziemski",
                        "Moses Moody",
                        "Jimmy Butler",
                        "Draymond Green"
                    ]
                },
                "home": {
                    "teamNickname": "Kings",
                    "projectedPlayers": [
                        "Malik Monk",
                        "Zach LaVine",
                        "DeMar DeRozan",
                        "Keegan Murray",
                        "Domantas Sabonis"
                    ]
                }
            }
        ],
        "isError": false
    }
}

export const oddsEventsMockResp = {
    "isError": false,
    "errorMessage": null,
    "data": [
        {
            "id": "9a5cee259a4c70367132f4fb6f90be03",
            "sportKey": "basketball_nba",
            "sportTitle": "NBA",
            "commenceTime": "2025-02-22T00:10:00Z",
            "homeTeam": "Cleveland Cavaliers",
            "awayTeam": "New York Knicks",
            "bookmakers": null
        },
        {
            "id": "e2c5133f68dd32d234a6abcb91329cb4",
            "sportKey": "basketball_nba",
            "sportTitle": "NBA",
            "commenceTime": "2025-02-22T00:10:00Z",
            "homeTeam": "Orlando Magic",
            "awayTeam": "Memphis Grizzlies",
            "bookmakers": null
        },
        {
            "id": "a31abdc525bfcd0f5798a20d39f30cf7",
            "sportKey": "basketball_nba",
            "sportTitle": "NBA",
            "commenceTime": "2025-02-22T00:10:00Z",
            "homeTeam": "Washington Wizards",
            "awayTeam": "Milwaukee Bucks",
            "bookmakers": null
        },
        {
            "id": "fbfec0530e2ee30e2129c0cf827d2879",
            "sportKey": "basketball_nba",
            "sportTitle": "NBA",
            "commenceTime": "2025-02-22T00:40:00Z",
            "homeTeam": "Toronto Raptors",
            "awayTeam": "Miami Heat",
            "bookmakers": null
        },
        {
            "id": "baf21b863522236e0f0820c5017d701e",
            "sportKey": "basketball_nba",
            "sportTitle": "NBA",
            "commenceTime": "2025-02-22T01:40:00Z",
            "homeTeam": "Dallas Mavericks",
            "awayTeam": "New Orleans Pelicans",
            "bookmakers": null
        },
        {
            "id": "98e00329066852fb939287a87b7d4bbe",
            "sportKey": "basketball_nba",
            "sportTitle": "NBA",
            "commenceTime": "2025-02-22T01:40:00Z",
            "homeTeam": "San Antonio Spurs",
            "awayTeam": "Detroit Pistons",
            "bookmakers": null
        },
        {
            "id": "3fb43736cba951d402acbb6c24789959",
            "sportKey": "basketball_nba",
            "sportTitle": "NBA",
            "commenceTime": "2025-02-22T02:40:00Z",
            "homeTeam": "Houston Rockets",
            "awayTeam": "Minnesota Timberwolves",
            "bookmakers": null
        },
        {
            "id": "80924d9450380ce8acec0857974525e5",
            "sportKey": "basketball_nba",
            "sportTitle": "NBA",
            "commenceTime": "2025-02-22T02:40:00Z",
            "homeTeam": "Utah Jazz",
            "awayTeam": "Oklahoma City Thunder",
            "bookmakers": null
        },
        {
            "id": "91a18e6bafdbd28c64d962f13785148b",
            "sportKey": "basketball_nba",
            "sportTitle": "NBA",
            "commenceTime": "2025-02-22T03:10:00Z",
            "homeTeam": "Sacramento Kings",
            "awayTeam": "Golden State Warriors",
            "bookmakers": null
        },
        {
            "id": "8c5dfc09221b32ad1835ce0e5c426454",
            "sportKey": "basketball_nba",
            "sportTitle": "NBA",
            "commenceTime": "2025-02-26T03:00:00Z",
            "homeTeam": "Los Angeles Lakers",
            "awayTeam": "Dallas Mavericks",
            "bookmakers": null
        },
        {
            "id": "0e1dde121b5be88b7c95e744d43c877f",
            "sportKey": "basketball_nba",
            "sportTitle": "NBA",
            "commenceTime": "2025-03-26T00:40:00Z",
            "homeTeam": "Miami Heat",
            "awayTeam": "Golden State Warriors",
            "bookmakers": null
        }
    ]
};

export const knicksCavsPlayersOdds = {
    "isError": false,
    "errorMessage": null,
    "data": {
        "events": [
            {
                "id": "9a5cee259a4c70367132f4fb6f90be03",
                "sportKey": "basketball_nba",
                "sportTitle": "NBA",
                "commenceTime": "2025-02-22T00:10:00Z",
                "homeTeam": "Cleveland Cavaliers",
                "awayTeam": "New York Knicks",
                "bookmakers": [
                    {
                        "key": "fanduel",
                        "title": "FanDuel",
                        "lastUpdate": null,
                        "markets": [
                            {
                                "key": "player_assists",
                                "lastUpdate": "2025-02-21T18:39:47Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": 142,
                                        "description": "Evan Mobley",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -184,
                                        "description": "Evan Mobley",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -128,
                                        "description": "Darius Garland",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 100,
                                        "description": "Darius Garland",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 114,
                                        "description": "Donovan Mitchell",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -146,
                                        "description": "Donovan Mitchell",
                                        "point": 5.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points",
                                "lastUpdate": "2025-02-21T18:39:47Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -102,
                                        "description": "Max Strus",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Max Strus",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -106,
                                        "description": "Jarrett Allen",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Jarrett Allen",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -102,
                                        "description": "Darius Garland",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Darius Garland",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -113,
                                        "description": "Evan Mobley",
                                        "point": 17.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -113,
                                        "description": "Evan Mobley",
                                        "point": 17.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -113,
                                        "description": "Donovan Mitchell",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -113,
                                        "description": "Donovan Mitchell",
                                        "point": 24.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_assists",
                                "lastUpdate": "2025-02-21T18:39:47Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -122,
                                        "description": "Donovan Mitchell",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -104,
                                        "description": "Donovan Mitchell",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -122,
                                        "description": "Evan Mobley",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -104,
                                        "description": "Evan Mobley",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -104,
                                        "description": "Darius Garland",
                                        "point": 27.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -122,
                                        "description": "Darius Garland",
                                        "point": 27.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_rebounds",
                                "lastUpdate": "2025-02-21T18:39:47Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Donovan Mitchell",
                                        "point": 28.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -111,
                                        "description": "Donovan Mitchell",
                                        "point": 28.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Evan Mobley",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -111,
                                        "description": "Evan Mobley",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -111,
                                        "description": "Jarrett Allen",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Jarrett Allen",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Max Strus",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -128,
                                        "description": "Max Strus",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -113,
                                        "description": "Darius Garland",
                                        "point": 22.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -113,
                                        "description": "Darius Garland",
                                        "point": 22.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_rebounds_assists",
                                "lastUpdate": "2025-02-21T18:39:47Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -104,
                                        "description": "Donovan Mitchell",
                                        "point": 34.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -122,
                                        "description": "Donovan Mitchell",
                                        "point": 34.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -113,
                                        "description": "Darius Garland",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -113,
                                        "description": "Darius Garland",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -122,
                                        "description": "Evan Mobley",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -104,
                                        "description": "Evan Mobley",
                                        "point": 29.5
                                    }
                                ]
                            },
                            {
                                "key": "player_rebounds",
                                "lastUpdate": "2025-02-21T18:39:47Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -166,
                                        "description": "Donovan Mitchell",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 130,
                                        "description": "Donovan Mitchell",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -140,
                                        "description": "Max Strus",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 110,
                                        "description": "Max Strus",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -140,
                                        "description": "Jarrett Allen",
                                        "point": 10.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 110,
                                        "description": "Jarrett Allen",
                                        "point": 10.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 124,
                                        "description": "Darius Garland",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -160,
                                        "description": "Darius Garland",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 108,
                                        "description": "Evan Mobley",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -138,
                                        "description": "Evan Mobley",
                                        "point": 9.5
                                    }
                                ]
                            },
                            {
                                "key": "player_threes",
                                "lastUpdate": "2025-02-21T18:39:47Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": 136,
                                        "description": "Max Strus",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -174,
                                        "description": "Max Strus",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -140,
                                        "description": "Darius Garland",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 110,
                                        "description": "Darius Garland",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 110,
                                        "description": "Donovan Mitchell",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -140,
                                        "description": "Donovan Mitchell",
                                        "point": 3.5
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "key": "draftkings",
                        "title": "DraftKings",
                        "lastUpdate": null,
                        "markets": [
                            {
                                "key": "player_assists",
                                "lastUpdate": "2025-02-21T18:39:38Z",
                                "outcomes": [
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Jalen Brunson",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Jalen Brunson",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -135,
                                        "description": "Darius Garland",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 105,
                                        "description": "Darius Garland",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 114,
                                        "description": "Donovan Mitchell",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -145,
                                        "description": "Donovan Mitchell",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Mikal Bridges",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Mikal Bridges",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Karl-Anthony Towns",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Karl-Anthony Towns",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -175,
                                        "description": "Evan Mobley",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 135,
                                        "description": "Evan Mobley",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 100,
                                        "description": "Max Strus",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -130,
                                        "description": "Max Strus",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -195,
                                        "description": "Jarrett Allen",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 150,
                                        "description": "Jarrett Allen",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 140,
                                        "description": "OG Anunoby",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -180,
                                        "description": "OG Anunoby",
                                        "point": 1.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points",
                                "lastUpdate": "2025-02-21T18:38:29Z",
                                "outcomes": [
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Jalen Brunson",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Jalen Brunson",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Donovan Mitchell",
                                        "point": 25.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Donovan Mitchell",
                                        "point": 25.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Karl-Anthony Towns",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Karl-Anthony Towns",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Darius Garland",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Darius Garland",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Evan Mobley",
                                        "point": 17.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Evan Mobley",
                                        "point": 17.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Mikal Bridges",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Mikal Bridges",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "OG Anunoby",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "OG Anunoby",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "De'Andre Hunter",
                                        "point": 13.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "De'Andre Hunter",
                                        "point": 13.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Jarrett Allen",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Jarrett Allen",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Max Strus",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Max Strus",
                                        "point": 8.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_assists",
                                "lastUpdate": "2025-02-21T18:38:31Z",
                                "outcomes": [
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Jalen Brunson",
                                        "point": 35.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Jalen Brunson",
                                        "point": 35.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Donovan Mitchell",
                                        "point": 30.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Donovan Mitchell",
                                        "point": 30.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Darius Garland",
                                        "point": 27.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Darius Garland",
                                        "point": 27.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Karl-Anthony Towns",
                                        "point": 27.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Karl-Anthony Towns",
                                        "point": 27.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Evan Mobley",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Evan Mobley",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Mikal Bridges",
                                        "point": 19.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Mikal Bridges",
                                        "point": 19.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "OG Anunoby",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "OG Anunoby",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Jarrett Allen",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Jarrett Allen",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Max Strus",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Max Strus",
                                        "point": 11.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_rebounds",
                                "lastUpdate": "2025-02-21T18:38:31Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Karl-Anthony Towns",
                                        "point": 36.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Karl-Anthony Towns",
                                        "point": 36.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Jalen Brunson",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Jalen Brunson",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Donovan Mitchell",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Donovan Mitchell",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Evan Mobley",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Evan Mobley",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Jarrett Allen",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Jarrett Allen",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Darius Garland",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Darius Garland",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Mikal Bridges",
                                        "point": 19.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Mikal Bridges",
                                        "point": 19.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "OG Anunoby",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "OG Anunoby",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "De'Andre Hunter",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "De'Andre Hunter",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Max Strus",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Max Strus",
                                        "point": 12.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_rebounds_assists",
                                "lastUpdate": "2025-02-21T18:38:31Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Karl-Anthony Towns",
                                        "point": 40.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Karl-Anthony Towns",
                                        "point": 40.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Jalen Brunson",
                                        "point": 38.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Jalen Brunson",
                                        "point": 38.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Donovan Mitchell",
                                        "point": 34.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Donovan Mitchell",
                                        "point": 34.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Darius Garland",
                                        "point": 30.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Darius Garland",
                                        "point": 30.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Evan Mobley",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Evan Mobley",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Jarrett Allen",
                                        "point": 25.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Jarrett Allen",
                                        "point": 25.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Mikal Bridges",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Mikal Bridges",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "OG Anunoby",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "OG Anunoby",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "De'Andre Hunter",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "De'Andre Hunter",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Max Strus",
                                        "point": 15.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Max Strus",
                                        "point": 15.5
                                    }
                                ]
                            },
                            {
                                "key": "player_rebounds",
                                "lastUpdate": "2025-02-21T18:39:38Z",
                                "outcomes": [
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Karl-Anthony Towns",
                                        "point": 13.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Karl-Anthony Towns",
                                        "point": 13.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -135,
                                        "description": "Jarrett Allen",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 105,
                                        "description": "Jarrett Allen",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Evan Mobley",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Evan Mobley",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -160,
                                        "description": "OG Anunoby",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 124,
                                        "description": "OG Anunoby",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 120,
                                        "description": "Donovan Mitchell",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -154,
                                        "description": "Donovan Mitchell",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -154,
                                        "description": "Max Strus",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 120,
                                        "description": "Max Strus",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Mikal Bridges",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Mikal Bridges",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 105,
                                        "description": "De'Andre Hunter",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -135,
                                        "description": "De'Andre Hunter",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 124,
                                        "description": "Jalen Brunson",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -160,
                                        "description": "Jalen Brunson",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -154,
                                        "description": "Darius Garland",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 120,
                                        "description": "Darius Garland",
                                        "point": 2.5
                                    }
                                ]
                            },
                            {
                                "key": "player_threes",
                                "lastUpdate": "2025-02-21T18:39:38Z",
                                "outcomes": [
                                    {
                                        "name": "Under",
                                        "price": -160,
                                        "description": "Donovan Mitchell",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 124,
                                        "description": "Donovan Mitchell",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -145,
                                        "description": "Darius Garland",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 114,
                                        "description": "Darius Garland",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -160,
                                        "description": "Jalen Brunson",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 124,
                                        "description": "Jalen Brunson",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -180,
                                        "description": "Max Strus",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 140,
                                        "description": "Max Strus",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 140,
                                        "description": "Karl-Anthony Towns",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -180,
                                        "description": "Karl-Anthony Towns",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 135,
                                        "description": "De'Andre Hunter",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -175,
                                        "description": "De'Andre Hunter",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -154,
                                        "description": "OG Anunoby",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 120,
                                        "description": "OG Anunoby",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 114,
                                        "description": "Mikal Bridges",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -145,
                                        "description": "Mikal Bridges",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -180,
                                        "description": "Evan Mobley",
                                        "point": 0.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 140,
                                        "description": "Evan Mobley",
                                        "point": 0.5
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "key": "betmgm",
                        "title": "BetMGM",
                        "lastUpdate": null,
                        "markets": [
                            {
                                "key": "player_assists",
                                "lastUpdate": "2025-02-21T18:40:11Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -140,
                                        "description": "Evan Mobley",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 105,
                                        "description": "Evan Mobley",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -135,
                                        "description": "Darius Garland",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 100,
                                        "description": "Darius Garland",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 135,
                                        "description": "De'Andre Hunter",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -175,
                                        "description": "De'Andre Hunter",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -140,
                                        "description": "Max Strus",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 105,
                                        "description": "Max Strus",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 105,
                                        "description": "Donovan Mitchell",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -140,
                                        "description": "Donovan Mitchell",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -190,
                                        "description": "Jarrett Allen",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 145,
                                        "description": "Jarrett Allen",
                                        "point": 1.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points",
                                "lastUpdate": "2025-02-21T18:40:11Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Jarrett Allen",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Jarrett Allen",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -145,
                                        "description": "Evan Mobley",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 110,
                                        "description": "Evan Mobley",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Darius Garland",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Darius Garland",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "De'Andre Hunter",
                                        "point": 13.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "De'Andre Hunter",
                                        "point": 13.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Max Strus",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Max Strus",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Donovan Mitchell",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Donovan Mitchell",
                                        "point": 24.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_assists",
                                "lastUpdate": "2025-02-21T18:40:11Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Jarrett Allen",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Jarrett Allen",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Evan Mobley",
                                        "point": 19.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Evan Mobley",
                                        "point": 19.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Darius Garland",
                                        "point": 27.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Darius Garland",
                                        "point": 27.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -118,
                                        "description": "De'Andre Hunter",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "De'Andre Hunter",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -118,
                                        "description": "Max Strus",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Max Strus",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Donovan Mitchell",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Donovan Mitchell",
                                        "point": 29.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_rebounds",
                                "lastUpdate": "2025-02-21T18:40:11Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -135,
                                        "description": "Jarrett Allen",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 100,
                                        "description": "Jarrett Allen",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Evan Mobley",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Evan Mobley",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Darius Garland",
                                        "point": 22.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Darius Garland",
                                        "point": 22.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "De'Andre Hunter",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "De'Andre Hunter",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Max Strus",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Max Strus",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Donovan Mitchell",
                                        "point": 28.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Donovan Mitchell",
                                        "point": 28.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -150,
                                        "description": "Jarrett Allen",
                                        "point": 22.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 115,
                                        "description": "Jarrett Allen",
                                        "point": 22.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_rebounds_assists",
                                "lastUpdate": "2025-02-21T18:40:11Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -145,
                                        "description": "Jarrett Allen",
                                        "point": 25.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 110,
                                        "description": "Jarrett Allen",
                                        "point": 25.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Darius Garland",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Darius Garland",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "De'Andre Hunter",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "De'Andre Hunter",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Max Strus",
                                        "point": 15.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Max Strus",
                                        "point": 15.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Jalen Brunson",
                                        "point": 38.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -135,
                                        "description": "Jalen Brunson",
                                        "point": 38.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -130,
                                        "description": "Evan Mobley",
                                        "point": 28.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Evan Mobley",
                                        "point": 28.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Donovan Mitchell",
                                        "point": 34.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Donovan Mitchell",
                                        "point": 34.5
                                    }
                                ]
                            },
                            {
                                "key": "player_rebounds",
                                "lastUpdate": "2025-02-21T18:40:11Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": 110,
                                        "description": "Evan Mobley",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -145,
                                        "description": "Evan Mobley",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 105,
                                        "description": "Darius Garland",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -145,
                                        "description": "Darius Garland",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "De'Andre Hunter",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "De'Andre Hunter",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -150,
                                        "description": "Max Strus",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 110,
                                        "description": "Max Strus",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -160,
                                        "description": "Donovan Mitchell",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 120,
                                        "description": "Donovan Mitchell",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Jarrett Allen",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Jarrett Allen",
                                        "point": 11.5
                                    }
                                ]
                            },
                            {
                                "key": "player_threes",
                                "lastUpdate": "2025-02-21T18:40:11Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -175,
                                        "description": "Evan Mobley",
                                        "point": 0.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 130,
                                        "description": "Evan Mobley",
                                        "point": 0.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -145,
                                        "description": "Darius Garland",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 110,
                                        "description": "Darius Garland",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -190,
                                        "description": "De'Andre Hunter",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 140,
                                        "description": "De'Andre Hunter",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 140,
                                        "description": "Max Strus",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -190,
                                        "description": "Max Strus",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 120,
                                        "description": "Donovan Mitchell",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -160,
                                        "description": "Donovan Mitchell",
                                        "point": 3.5
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "teamOptimalOddsMap": {
            "9a5cee259a4c70367132f4fb6f90be03": [
                {
                    "bookmaker": "BetMGM",
                    "name": "Under",
                    "price": 115,
                    "betType": "player_points_rebounds",
                    "point": 22.5,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Over",
                    "price": 124,
                    "betType": "player_rebounds",
                    "point": 2.5,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Over",
                    "price": -104,
                    "betType": "player_points_assists",
                    "point": 27.5,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Over",
                    "price": 100,
                    "betType": "player_points_rebounds",
                    "point": 12.5,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Over",
                    "price": 142,
                    "betType": "player_assists",
                    "point": 3.5,
                    "playerName": null
                },
                {
                    "bookmaker": "BetMGM",
                    "name": "Over",
                    "price": 100,
                    "betType": "player_points_rebounds_assists",
                    "point": 38.5,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Under",
                    "price": 130,
                    "betType": "player_rebounds",
                    "point": 3.5,
                    "playerName": null
                },
                {
                    "bookmaker": "DraftKings",
                    "name": "Under",
                    "price": 140,
                    "betType": "player_threes",
                    "point": 1.5,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Under",
                    "price": -104,
                    "betType": "player_points_assists",
                    "point": 29.5,
                    "playerName": null
                },
                {
                    "bookmaker": "DraftKings",
                    "name": "Under",
                    "price": 150,
                    "betType": "player_assists",
                    "point": 1.5,
                    "playerName": null
                },
                {
                    "bookmaker": "DraftKings",
                    "name": "Over",
                    "price": 140,
                    "betType": "player_threes",
                    "point": 2.5,
                    "playerName": null
                },
                {
                    "bookmaker": "DraftKings",
                    "name": "Over",
                    "price": 100,
                    "betType": "player_points",
                    "point": 12.5,
                    "playerName": null
                },
                {
                    "bookmaker": "BetMGM",
                    "name": "Under",
                    "price": 110,
                    "betType": "player_points",
                    "point": 16.5,
                    "playerName": null
                },
                {
                    "bookmaker": "BetMGM",
                    "name": "Under",
                    "price": 110,
                    "betType": "player_points_rebounds_assists",
                    "point": 25.5,
                    "playerName": null
                }
            ]
        },
        "playerOptimalOddsMap": {
            "9a5cee259a4c70367132f4fb6f90be03": {
                "De'Andre Hunter": [
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 135,
                        "betType": "player_assists",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -118,
                        "betType": "player_points_assists",
                        "point": 14.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": 140,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -175,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 105,
                        "betType": "player_rebounds",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -120,
                        "betType": "player_rebounds",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points_rebounds",
                        "point": 16.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -115,
                        "betType": "player_points_rebounds_assists",
                        "point": 18.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -120,
                        "betType": "player_points_rebounds",
                        "point": 16.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -125,
                        "betType": "player_points",
                        "point": 13.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points",
                        "point": 13.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -175,
                        "betType": "player_assists",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_rebounds_assists",
                        "point": 18.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_assists",
                        "point": 14.5,
                        "playerName": null
                    }
                ],
                "OG Anunoby": [
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_assists",
                        "point": 16.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_rebounds",
                        "point": 18.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -160,
                        "betType": "player_rebounds",
                        "point": 4.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 140,
                        "betType": "player_assists",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points",
                        "point": 14.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -120,
                        "betType": "player_points_rebounds_assists",
                        "point": 20.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points_rebounds_assists",
                        "point": 20.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 120,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -180,
                        "betType": "player_assists",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -125,
                        "betType": "player_points",
                        "point": 14.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -125,
                        "betType": "player_points_assists",
                        "point": 16.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 124,
                        "betType": "player_rebounds",
                        "point": 4.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -154,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -125,
                        "betType": "player_points_rebounds",
                        "point": 18.5,
                        "playerName": null
                    }
                ],
                "Mikal Bridges": [
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 114,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_rebounds",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_assists",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -125,
                        "betType": "player_points",
                        "point": 16.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points",
                        "point": 16.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_rebounds",
                        "point": 19.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -120,
                        "betType": "player_points_rebounds",
                        "point": 19.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points_rebounds_assists",
                        "point": 23.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -120,
                        "betType": "player_rebounds",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points_assists",
                        "point": 19.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -120,
                        "betType": "player_assists",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -145,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -120,
                        "betType": "player_points_rebounds_assists",
                        "point": 23.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -125,
                        "betType": "player_points_assists",
                        "point": 19.5,
                        "playerName": null
                    }
                ],
                "Evan Mobley": [
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": 110,
                        "betType": "player_points",
                        "point": 16.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 110,
                        "betType": "player_rebounds",
                        "point": 9.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -130,
                        "betType": "player_rebounds",
                        "point": 9.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -115,
                        "betType": "player_points_rebounds",
                        "point": 26.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -120,
                        "betType": "player_points_rebounds_assists",
                        "point": 29.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -175,
                        "betType": "player_threes",
                        "point": 0.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 140,
                        "betType": "player_threes",
                        "point": 0.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -104,
                        "betType": "player_points_assists",
                        "point": 20.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points",
                        "point": 17.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points_rebounds",
                        "point": 26.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": 142,
                        "betType": "player_assists",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -115,
                        "betType": "player_points_assists",
                        "point": 20.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 135,
                        "betType": "player_assists",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -104,
                        "betType": "player_points_rebounds_assists",
                        "point": 29.5,
                        "playerName": null
                    }
                ],
                "Donovan Mitchell": [
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": 114,
                        "betType": "player_assists",
                        "point": 5.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points",
                        "point": 25.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -140,
                        "betType": "player_assists",
                        "point": 5.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -111,
                        "betType": "player_points_rebounds",
                        "point": 28.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": 130,
                        "betType": "player_rebounds",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 124,
                        "betType": "player_threes",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -140,
                        "betType": "player_threes",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points",
                        "point": 24.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -120,
                        "betType": "player_points_rebounds_assists",
                        "point": 34.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points_assists",
                        "point": 30.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -104,
                        "betType": "player_points_assists",
                        "point": 29.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -104,
                        "betType": "player_points_rebounds_assists",
                        "point": 34.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -154,
                        "betType": "player_rebounds",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points_rebounds",
                        "point": 29.5,
                        "playerName": null
                    }
                ],
                "Jalen Brunson": [
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -120,
                        "betType": "player_points_rebounds_assists",
                        "point": 38.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -160,
                        "betType": "player_rebounds",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points_assists",
                        "point": 35.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -115,
                        "betType": "player_assists",
                        "point": 8.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -115,
                        "betType": "player_points",
                        "point": 26.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -120,
                        "betType": "player_points_assists",
                        "point": 35.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_rebounds",
                        "point": 29.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -120,
                        "betType": "player_points_rebounds",
                        "point": 29.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 100,
                        "betType": "player_points_rebounds_assists",
                        "point": 38.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 124,
                        "betType": "player_rebounds",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -115,
                        "betType": "player_assists",
                        "point": 8.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 124,
                        "betType": "player_threes",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -115,
                        "betType": "player_points",
                        "point": 26.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -160,
                        "betType": "player_threes",
                        "point": 2.5,
                        "playerName": null
                    }
                ],
                "Jarrett Allen": [
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_assists",
                        "point": 14.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_assists",
                        "point": 14.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 105,
                        "betType": "player_rebounds",
                        "point": 11.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": 110,
                        "betType": "player_rebounds",
                        "point": 10.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 100,
                        "betType": "player_points",
                        "point": 12.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -190,
                        "betType": "player_assists",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -120,
                        "betType": "player_points",
                        "point": 12.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points_rebounds",
                        "point": 23.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 150,
                        "betType": "player_assists",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": 115,
                        "betType": "player_points_rebounds",
                        "point": 22.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -115,
                        "betType": "player_points_rebounds_assists",
                        "point": 25.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": 110,
                        "betType": "player_points_rebounds_assists",
                        "point": 25.5,
                        "playerName": null
                    }
                ],
                "Max Strus": [
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -174,
                        "betType": "player_threes",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_assists",
                        "point": 11.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -130,
                        "betType": "player_assists",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -102,
                        "betType": "player_points",
                        "point": 8.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_rebounds",
                        "point": 12.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": 105,
                        "betType": "player_assists",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -140,
                        "betType": "player_rebounds",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_assists",
                        "point": 11.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points_rebounds_assists",
                        "point": 15.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points",
                        "point": 8.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 140,
                        "betType": "player_threes",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": 100,
                        "betType": "player_points_rebounds",
                        "point": 12.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 120,
                        "betType": "player_rebounds",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -120,
                        "betType": "player_points_rebounds_assists",
                        "point": 15.5,
                        "playerName": null
                    }
                ],
                "Darius Garland": [
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_rebounds_assists",
                        "point": 30.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -102,
                        "betType": "player_points",
                        "point": 20.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": 124,
                        "betType": "player_rebounds",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -145,
                        "betType": "player_rebounds",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 114,
                        "betType": "player_threes",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -104,
                        "betType": "player_points_assists",
                        "point": 27.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -113,
                        "betType": "player_points_rebounds",
                        "point": 22.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_rebounds",
                        "point": 23.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -140,
                        "betType": "player_threes",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_assists",
                        "point": 27.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -128,
                        "betType": "player_assists",
                        "point": 6.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 105,
                        "betType": "player_assists",
                        "point": 6.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points",
                        "point": 20.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -113,
                        "betType": "player_points_rebounds_assists",
                        "point": 29.5,
                        "playerName": null
                    }
                ],
                "Karl-Anthony Towns": [
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -125,
                        "betType": "player_rebounds",
                        "point": 13.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_rebounds",
                        "point": 13.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -180,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points_rebounds",
                        "point": 36.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 140,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points",
                        "point": 23.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 100,
                        "betType": "player_assists",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -115,
                        "betType": "player_points_rebounds_assists",
                        "point": 40.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -130,
                        "betType": "player_assists",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -120,
                        "betType": "player_points_assists",
                        "point": 27.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_assists",
                        "point": 27.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -115,
                        "betType": "player_points_rebounds_assists",
                        "point": 40.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -125,
                        "betType": "player_points",
                        "point": 23.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -125,
                        "betType": "player_points_rebounds",
                        "point": 36.5,
                        "playerName": null
                    }
                ]
            }
        }
    }
};

export const knicksCavsTeamOdds = {
    "isError": false,
    "errorMessage": null,
    "data": {
        "events": [
            {
                "id": "9a5cee259a4c70367132f4fb6f90be03",
                "sportKey": "basketball_nba",
                "sportTitle": "NBA",
                "commenceTime": "2025-02-22T00:10:00Z",
                "homeTeam": "Cleveland Cavaliers",
                "awayTeam": "New York Knicks",
                "bookmakers": [
                    {
                        "key": "fanduel",
                        "title": "FanDuel",
                        "lastUpdate": null,
                        "markets": [
                            {
                                "key": "h2h",
                                "lastUpdate": "2025-02-21T18:37:17Z",
                                "outcomes": [
                                    {
                                        "name": "Cleveland Cavaliers",
                                        "price": -330,
                                        "description": null,
                                        "point": null
                                    },
                                    {
                                        "name": "New York Knicks",
                                        "price": 265,
                                        "description": null,
                                        "point": null
                                    }
                                ]
                            },
                            {
                                "key": "spreads",
                                "lastUpdate": "2025-02-21T18:37:17Z",
                                "outcomes": [
                                    {
                                        "name": "Cleveland Cavaliers",
                                        "price": -110,
                                        "description": null,
                                        "point": -8.5
                                    },
                                    {
                                        "name": "New York Knicks",
                                        "price": -110,
                                        "description": null,
                                        "point": 8.5
                                    }
                                ]
                            },
                            {
                                "key": "totals",
                                "lastUpdate": "2025-02-21T18:37:17Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": null,
                                        "point": 240.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": null,
                                        "point": 240.5
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "key": "draftkings",
                        "title": "DraftKings",
                        "lastUpdate": null,
                        "markets": [
                            {
                                "key": "h2h",
                                "lastUpdate": "2025-02-21T18:39:08Z",
                                "outcomes": [
                                    {
                                        "name": "Cleveland Cavaliers",
                                        "price": -360,
                                        "description": null,
                                        "point": null
                                    },
                                    {
                                        "name": "New York Knicks",
                                        "price": 285,
                                        "description": null,
                                        "point": null
                                    }
                                ]
                            },
                            {
                                "key": "spreads",
                                "lastUpdate": "2025-02-21T18:39:08Z",
                                "outcomes": [
                                    {
                                        "name": "Cleveland Cavaliers",
                                        "price": -110,
                                        "description": null,
                                        "point": -8.5
                                    },
                                    {
                                        "name": "New York Knicks",
                                        "price": -110,
                                        "description": null,
                                        "point": 8.5
                                    }
                                ]
                            },
                            {
                                "key": "totals",
                                "lastUpdate": "2025-02-21T18:39:08Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -112,
                                        "description": null,
                                        "point": 240.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -108,
                                        "description": null,
                                        "point": 240.5
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "key": "betmgm",
                        "title": "BetMGM",
                        "lastUpdate": null,
                        "markets": [
                            {
                                "key": "h2h",
                                "lastUpdate": "2025-02-21T18:39:08Z",
                                "outcomes": [
                                    {
                                        "name": "Cleveland Cavaliers",
                                        "price": -350,
                                        "description": null,
                                        "point": null
                                    },
                                    {
                                        "name": "New York Knicks",
                                        "price": 280,
                                        "description": null,
                                        "point": null
                                    }
                                ]
                            },
                            {
                                "key": "spreads",
                                "lastUpdate": "2025-02-21T18:39:08Z",
                                "outcomes": [
                                    {
                                        "name": "Cleveland Cavaliers",
                                        "price": -110,
                                        "description": null,
                                        "point": -8.5
                                    },
                                    {
                                        "name": "New York Knicks",
                                        "price": -110,
                                        "description": null,
                                        "point": 8.5
                                    }
                                ]
                            },
                            {
                                "key": "totals",
                                "lastUpdate": "2025-02-21T18:39:08Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": null,
                                        "point": 241.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": null,
                                        "point": 241.5
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "teamOptimalOddsMap": {
            "9a5cee259a4c70367132f4fb6f90be03": [
                {
                    "bookmaker": "BetMGM",
                    "name": "Over",
                    "price": -105,
                    "betType": "totals",
                    "point": 241.5,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "New York Knicks",
                    "price": -110,
                    "betType": "spreads",
                    "point": 8.5,
                    "playerName": null
                },
                {
                    "bookmaker": "DraftKings",
                    "name": "Under",
                    "price": -108,
                    "betType": "totals",
                    "point": 240.5,
                    "playerName": null
                },
                {
                    "bookmaker": "DraftKings",
                    "name": "New York Knicks",
                    "price": 285,
                    "betType": "h2h",
                    "point": null,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Cleveland Cavaliers",
                    "price": -330,
                    "betType": "h2h",
                    "point": null,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Cleveland Cavaliers",
                    "price": -110,
                    "betType": "spreads",
                    "point": -8.5,
                    "playerName": null
                }
            ]
        },
        "playerOptimalOddsMap": {
            "9a5cee259a4c70367132f4fb6f90be03": {}
        }
    }
};

export const grizzliesMagicTeamOdds = {
    "isError": false,
    "errorMessage": null,
    "data": {
        "events": [
            {
                "id": "e2c5133f68dd32d234a6abcb91329cb4",
                "sportKey": "basketball_nba",
                "sportTitle": "NBA",
                "commenceTime": "2025-02-22T00:10:00Z",
                "homeTeam": "Orlando Magic",
                "awayTeam": "Memphis Grizzlies",
                "bookmakers": [
                    {
                        "key": "fanduel",
                        "title": "FanDuel",
                        "lastUpdate": null,
                        "markets": [
                            {
                                "key": "h2h",
                                "lastUpdate": "2025-02-21T18:43:16Z",
                                "outcomes": [
                                    {
                                        "name": "Memphis Grizzlies",
                                        "price": -172,
                                        "description": null,
                                        "point": null
                                    },
                                    {
                                        "name": "Orlando Magic",
                                        "price": 144,
                                        "description": null,
                                        "point": null
                                    }
                                ]
                            },
                            {
                                "key": "spreads",
                                "lastUpdate": "2025-02-21T18:43:16Z",
                                "outcomes": [
                                    {
                                        "name": "Memphis Grizzlies",
                                        "price": -114,
                                        "description": null,
                                        "point": -4
                                    },
                                    {
                                        "name": "Orlando Magic",
                                        "price": -106,
                                        "description": null,
                                        "point": 4
                                    }
                                ]
                            },
                            {
                                "key": "totals",
                                "lastUpdate": "2025-02-21T18:43:16Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": null,
                                        "point": 226
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": null,
                                        "point": 226
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "key": "draftkings",
                        "title": "DraftKings",
                        "lastUpdate": null,
                        "markets": [
                            {
                                "key": "h2h",
                                "lastUpdate": "2025-02-21T18:43:12Z",
                                "outcomes": [
                                    {
                                        "name": "Memphis Grizzlies",
                                        "price": -180,
                                        "description": null,
                                        "point": null
                                    },
                                    {
                                        "name": "Orlando Magic",
                                        "price": 150,
                                        "description": null,
                                        "point": null
                                    }
                                ]
                            },
                            {
                                "key": "spreads",
                                "lastUpdate": "2025-02-21T18:43:12Z",
                                "outcomes": [
                                    {
                                        "name": "Memphis Grizzlies",
                                        "price": -108,
                                        "description": null,
                                        "point": -4.5
                                    },
                                    {
                                        "name": "Orlando Magic",
                                        "price": -112,
                                        "description": null,
                                        "point": 4.5
                                    }
                                ]
                            },
                            {
                                "key": "totals",
                                "lastUpdate": "2025-02-21T18:43:12Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -112,
                                        "description": null,
                                        "point": 226
                                    },
                                    {
                                        "name": "Under",
                                        "price": -108,
                                        "description": null,
                                        "point": 226
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "key": "betmgm",
                        "title": "BetMGM",
                        "lastUpdate": null,
                        "markets": [
                            {
                                "key": "h2h",
                                "lastUpdate": "2025-02-21T18:43:12Z",
                                "outcomes": [
                                    {
                                        "name": "Memphis Grizzlies",
                                        "price": -185,
                                        "description": null,
                                        "point": null
                                    },
                                    {
                                        "name": "Orlando Magic",
                                        "price": 150,
                                        "description": null,
                                        "point": null
                                    }
                                ]
                            },
                            {
                                "key": "spreads",
                                "lastUpdate": "2025-02-21T18:43:12Z",
                                "outcomes": [
                                    {
                                        "name": "Memphis Grizzlies",
                                        "price": -110,
                                        "description": null,
                                        "point": -4.5
                                    },
                                    {
                                        "name": "Orlando Magic",
                                        "price": -110,
                                        "description": null,
                                        "point": 4.5
                                    }
                                ]
                            },
                            {
                                "key": "totals",
                                "lastUpdate": "2025-02-21T18:43:12Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": null,
                                        "point": 226.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": null,
                                        "point": 226.5
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "teamOptimalOddsMap": {
            "e2c5133f68dd32d234a6abcb91329cb4": [
                {
                    "bookmaker": "FanDuel",
                    "name": "Over",
                    "price": -110,
                    "betType": "totals",
                    "point": 226,
                    "playerName": null
                },
                {
                    "bookmaker": "DraftKings",
                    "name": "Under",
                    "price": -108,
                    "betType": "totals",
                    "point": 226,
                    "playerName": null
                },
                {
                    "bookmaker": "DraftKings",
                    "name": "Memphis Grizzlies",
                    "price": -108,
                    "betType": "spreads",
                    "point": -4.5,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Orlando Magic",
                    "price": -106,
                    "betType": "spreads",
                    "point": 4,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Memphis Grizzlies",
                    "price": -172,
                    "betType": "h2h",
                    "point": null,
                    "playerName": null
                },
                {
                    "bookmaker": "DraftKings",
                    "name": "Orlando Magic",
                    "price": 150,
                    "betType": "h2h",
                    "point": null,
                    "playerName": null
                }
            ]
        },
        "playerOptimalOddsMap": {
            "e2c5133f68dd32d234a6abcb91329cb4": {}
        }
    }
};



export const grizzliesMagicPlayerOdds = {
    "isError": false,
    "errorMessage": null,
    "data": {
        "events": [
            {
                "id": "e2c5133f68dd32d234a6abcb91329cb4",
                "sportKey": "basketball_nba",
                "sportTitle": "NBA",
                "commenceTime": "2025-02-22T00:10:00Z",
                "homeTeam": "Orlando Magic",
                "awayTeam": "Memphis Grizzlies",
                "bookmakers": [
                    {
                        "key": "fanduel",
                        "title": "FanDuel",
                        "lastUpdate": null,
                        "markets": [
                            {
                                "key": "player_assists",
                                "lastUpdate": "2025-02-21T18:43:06Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": 106,
                                        "description": "Cole Anthony",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -136,
                                        "description": "Cole Anthony",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 102,
                                        "description": "Paolo Banchero",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Paolo Banchero",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 124,
                                        "description": "Franz Wagner",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -160,
                                        "description": "Franz Wagner",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -113,
                                        "description": "Ja Morant",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -113,
                                        "description": "Ja Morant",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -142,
                                        "description": "Desmond Bane",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 112,
                                        "description": "Desmond Bane",
                                        "point": 4.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points",
                                "lastUpdate": "2025-02-21T18:43:06Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Ja Morant",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -106,
                                        "description": "Ja Morant",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Cole Anthony",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -102,
                                        "description": "Cole Anthony",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -102,
                                        "description": "Paolo Banchero",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Paolo Banchero",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -128,
                                        "description": "Desmond Bane",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 100,
                                        "description": "Desmond Bane",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -130,
                                        "description": "Wendell Carter Jr",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 100,
                                        "description": "Wendell Carter Jr",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Franz Wagner",
                                        "point": 25.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -102,
                                        "description": "Franz Wagner",
                                        "point": 25.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -128,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Santi Aldama",
                                        "point": 10.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -111,
                                        "description": "Santi Aldama",
                                        "point": 10.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Jaylen Wells",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -102,
                                        "description": "Jaylen Wells",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -128,
                                        "description": "Zach Edey",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 100,
                                        "description": "Zach Edey",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -102,
                                        "description": "Jaren Jackson Jr",
                                        "point": 21.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Jaren Jackson Jr",
                                        "point": 21.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_assists",
                                "lastUpdate": "2025-02-21T18:43:06Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -106,
                                        "description": "Cole Anthony",
                                        "point": 15.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Cole Anthony",
                                        "point": 15.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -118,
                                        "description": "Paolo Banchero",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -108,
                                        "description": "Paolo Banchero",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -108,
                                        "description": "Franz Wagner",
                                        "point": 30.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -118,
                                        "description": "Franz Wagner",
                                        "point": 30.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -113,
                                        "description": "Ja Morant",
                                        "point": 27.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -113,
                                        "description": "Ja Morant",
                                        "point": 27.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -102,
                                        "description": "Desmond Bane",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Desmond Bane",
                                        "point": 24.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_rebounds",
                                "lastUpdate": "2025-02-21T18:43:06Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -113,
                                        "description": "Santi Aldama",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -113,
                                        "description": "Santi Aldama",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -113,
                                        "description": "Franz Wagner",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -113,
                                        "description": "Franz Wagner",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Zach Edey",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -128,
                                        "description": "Zach Edey",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -106,
                                        "description": "Wendell Carter Jr",
                                        "point": 17.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Wendell Carter Jr",
                                        "point": 17.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Jaylen Wells",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -102,
                                        "description": "Jaylen Wells",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -111,
                                        "description": "Cole Anthony",
                                        "point": 15.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Cole Anthony",
                                        "point": 15.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -122,
                                        "description": "Jaren Jackson Jr",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -104,
                                        "description": "Jaren Jackson Jr",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -104,
                                        "description": "Ja Morant",
                                        "point": 25.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -122,
                                        "description": "Ja Morant",
                                        "point": 25.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -118,
                                        "description": "Desmond Bane",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -108,
                                        "description": "Desmond Bane",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -106,
                                        "description": "Paolo Banchero",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Paolo Banchero",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -111,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 9.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_rebounds_assists",
                                "lastUpdate": "2025-02-21T18:43:06Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -118,
                                        "description": "Franz Wagner",
                                        "point": 35.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -108,
                                        "description": "Franz Wagner",
                                        "point": 35.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -122,
                                        "description": "Ja Morant",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -104,
                                        "description": "Ja Morant",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -122,
                                        "description": "Desmond Bane",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -104,
                                        "description": "Desmond Bane",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Paolo Banchero",
                                        "point": 36.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -106,
                                        "description": "Paolo Banchero",
                                        "point": 36.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Cole Anthony",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -102,
                                        "description": "Cole Anthony",
                                        "point": 18.5
                                    }
                                ]
                            },
                            {
                                "key": "player_rebounds",
                                "lastUpdate": "2025-02-21T18:43:06Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -154,
                                        "description": "Jaylen Wells",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 120,
                                        "description": "Jaylen Wells",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -122,
                                        "description": "Santi Aldama",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -104,
                                        "description": "Santi Aldama",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -102,
                                        "description": "Cole Anthony",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Cole Anthony",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 126,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -162,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -132,
                                        "description": "Paolo Banchero",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 104,
                                        "description": "Paolo Banchero",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 122,
                                        "description": "Wendell Carter Jr",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -154,
                                        "description": "Wendell Carter Jr",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -122,
                                        "description": "Jaren Jackson Jr",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -104,
                                        "description": "Jaren Jackson Jr",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Desmond Bane",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -111,
                                        "description": "Desmond Bane",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 106,
                                        "description": "Franz Wagner",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -136,
                                        "description": "Franz Wagner",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 114,
                                        "description": "Zach Edey",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -146,
                                        "description": "Zach Edey",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 114,
                                        "description": "Ja Morant",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -146,
                                        "description": "Ja Morant",
                                        "point": 4.5
                                    }
                                ]
                            },
                            {
                                "key": "player_threes",
                                "lastUpdate": "2025-02-21T18:43:06Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": 110,
                                        "description": "Cole Anthony",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -140,
                                        "description": "Cole Anthony",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -122,
                                        "description": "Santi Aldama",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -104,
                                        "description": "Santi Aldama",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 138,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -178,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -162,
                                        "description": "Franz Wagner",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 126,
                                        "description": "Franz Wagner",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 126,
                                        "description": "Jaylen Wells",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -162,
                                        "description": "Jaylen Wells",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -106,
                                        "description": "Ja Morant",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Ja Morant",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 132,
                                        "description": "Desmond Bane",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -170,
                                        "description": "Desmond Bane",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -172,
                                        "description": "Paolo Banchero",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 134,
                                        "description": "Paolo Banchero",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -104,
                                        "description": "Jaren Jackson Jr",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -122,
                                        "description": "Jaren Jackson Jr",
                                        "point": 1.5
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "key": "draftkings",
                        "title": "DraftKings",
                        "lastUpdate": null,
                        "markets": [
                            {
                                "key": "player_assists",
                                "lastUpdate": "2025-02-21T18:43:24Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -130,
                                        "description": "Ja Morant",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 100,
                                        "description": "Ja Morant",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Paolo Banchero",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Paolo Banchero",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 114,
                                        "description": "Desmond Bane",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -145,
                                        "description": "Desmond Bane",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Franz Wagner",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Franz Wagner",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Wendell Carter Jr",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Wendell Carter Jr",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 110,
                                        "description": "Jaren Jackson Jr",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -140,
                                        "description": "Jaren Jackson Jr",
                                        "point": 2.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points",
                                "lastUpdate": "2025-02-21T18:43:24Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Franz Wagner",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Franz Wagner",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Paolo Banchero",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Paolo Banchero",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Jaren Jackson Jr",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Jaren Jackson Jr",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Ja Morant",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Ja Morant",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Desmond Bane",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Desmond Bane",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Cole Anthony",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Cole Anthony",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Santi Aldama",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Santi Aldama",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Wendell Carter Jr",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Wendell Carter Jr",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 100,
                                        "description": "Jaylen Wells",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -130,
                                        "description": "Jaylen Wells",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -130,
                                        "description": "Zach Edey",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 100,
                                        "description": "Zach Edey",
                                        "point": 6.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_assists",
                                "lastUpdate": "2025-02-21T18:43:24Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Franz Wagner",
                                        "point": 30.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Franz Wagner",
                                        "point": 30.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Paolo Banchero",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Paolo Banchero",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Ja Morant",
                                        "point": 27.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Ja Morant",
                                        "point": 27.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Desmond Bane",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Desmond Bane",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Jaren Jackson Jr",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Jaren Jackson Jr",
                                        "point": 23.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Wendell Carter Jr",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Wendell Carter Jr",
                                        "point": 11.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_rebounds",
                                "lastUpdate": "2025-02-21T18:43:24Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Franz Wagner",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Franz Wagner",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Paolo Banchero",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Paolo Banchero",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Jaren Jackson Jr",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Jaren Jackson Jr",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Ja Morant",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Ja Morant",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Desmond Bane",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Desmond Bane",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Wendell Carter Jr",
                                        "point": 17.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Wendell Carter Jr",
                                        "point": 17.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Santi Aldama",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Santi Aldama",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Cole Anthony",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Cole Anthony",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Zach Edey",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Zach Edey",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Jaylen Wells",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Jaylen Wells",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 9.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_rebounds_assists",
                                "lastUpdate": "2025-02-21T18:43:24Z",
                                "outcomes": [
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Paolo Banchero",
                                        "point": 36.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Paolo Banchero",
                                        "point": 36.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Franz Wagner",
                                        "point": 36.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Franz Wagner",
                                        "point": 36.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Ja Morant",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Ja Morant",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Desmond Bane",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Desmond Bane",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Jaren Jackson Jr",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Jaren Jackson Jr",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Wendell Carter Jr",
                                        "point": 19.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Wendell Carter Jr",
                                        "point": 19.5
                                    }
                                ]
                            },
                            {
                                "key": "player_rebounds",
                                "lastUpdate": "2025-02-21T18:42:17Z",
                                "outcomes": [
                                    {
                                        "name": "Under",
                                        "price": 110,
                                        "description": "Wendell Carter Jr",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -140,
                                        "description": "Wendell Carter Jr",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Zach Edey",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Zach Edey",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -135,
                                        "description": "Paolo Banchero",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 105,
                                        "description": "Paolo Banchero",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -135,
                                        "description": "Jaren Jackson Jr",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 105,
                                        "description": "Jaren Jackson Jr",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Santi Aldama",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Santi Aldama",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Desmond Bane",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Desmond Bane",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -145,
                                        "description": "Franz Wagner",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 114,
                                        "description": "Franz Wagner",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 105,
                                        "description": "Ja Morant",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -135,
                                        "description": "Ja Morant",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Cole Anthony",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Cole Anthony",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 130,
                                        "description": "Jaylen Wells",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -166,
                                        "description": "Jaylen Wells",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -175,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 135,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 2.5
                                    }
                                ]
                            },
                            {
                                "key": "player_threes",
                                "lastUpdate": "2025-02-21T18:43:24Z",
                                "outcomes": [
                                    {
                                        "name": "Under",
                                        "price": -154,
                                        "description": "Desmond Bane",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 120,
                                        "description": "Desmond Bane",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 150,
                                        "description": "Paolo Banchero",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -195,
                                        "description": "Paolo Banchero",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 120,
                                        "description": "Franz Wagner",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -154,
                                        "description": "Franz Wagner",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Ja Morant",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Ja Morant",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Jaren Jackson Jr",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Jaren Jackson Jr",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 114,
                                        "description": "Jaylen Wells",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -145,
                                        "description": "Jaylen Wells",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -175,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 135,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 1.5
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "key": "betmgm",
                        "title": "BetMGM",
                        "lastUpdate": null,
                        "markets": [
                            {
                                "key": "player_assists",
                                "lastUpdate": "2025-02-21T18:43:35Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Ja Morant",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Ja Morant",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 135,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -185,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Wendell Carter Jr",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Wendell Carter Jr",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 130,
                                        "description": "Jaren Jackson Jr",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -175,
                                        "description": "Jaren Jackson Jr",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -140,
                                        "description": "Desmond Bane",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 105,
                                        "description": "Desmond Bane",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -220,
                                        "description": "Jaylen Wells",
                                        "point": 0.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 165,
                                        "description": "Jaylen Wells",
                                        "point": 0.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -118,
                                        "description": "Zach Edey",
                                        "point": 0.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Zach Edey",
                                        "point": 0.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Paolo Banchero",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Paolo Banchero",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -155,
                                        "description": "Santi Aldama",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 115,
                                        "description": "Santi Aldama",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 110,
                                        "description": "Cole Anthony",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -150,
                                        "description": "Cole Anthony",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -155,
                                        "description": "G.G. Jackson",
                                        "point": 0.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 115,
                                        "description": "G.G. Jackson",
                                        "point": 0.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -165,
                                        "description": "Franz Wagner",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 125,
                                        "description": "Franz Wagner",
                                        "point": 3.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points",
                                "lastUpdate": "2025-02-21T18:43:35Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -135,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -130,
                                        "description": "Wendell Carter Jr",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Wendell Carter Jr",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -118,
                                        "description": "Jaren Jackson Jr",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Jaren Jackson Jr",
                                        "point": 20.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 105,
                                        "description": "Desmond Bane",
                                        "point": 19.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -140,
                                        "description": "Desmond Bane",
                                        "point": 19.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Jaylen Wells",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Jaylen Wells",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Zach Edey",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Zach Edey",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Santi Aldama",
                                        "point": 10.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Santi Aldama",
                                        "point": 10.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Franz Wagner",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -118,
                                        "description": "Franz Wagner",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Cole Anthony",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Cole Anthony",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Paolo Banchero",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -118,
                                        "description": "Paolo Banchero",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -130,
                                        "description": "Ja Morant",
                                        "point": 19.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Ja Morant",
                                        "point": 19.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "G.G. Jackson",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "G.G. Jackson",
                                        "point": 8.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_assists",
                                "lastUpdate": "2025-02-21T18:43:35Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -118,
                                        "description": "Wendell Carter Jr",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Wendell Carter Jr",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -118,
                                        "description": "Franz Wagner",
                                        "point": 30.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Franz Wagner",
                                        "point": 30.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Desmond Bane",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Desmond Bane",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Jaylen Wells",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Jaylen Wells",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Zach Edey",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Zach Edey",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Paolo Banchero",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Paolo Banchero",
                                        "point": 29.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Jaren Jackson Jr",
                                        "point": 22.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Jaren Jackson Jr",
                                        "point": 22.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Santi Aldama",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Santi Aldama",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Ja Morant",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Ja Morant",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -118,
                                        "description": "G.G. Jackson",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "G.G. Jackson",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Cole Anthony",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Cole Anthony",
                                        "point": 14.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_rebounds",
                                "lastUpdate": "2025-02-21T18:43:35Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Ja Morant",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Ja Morant",
                                        "point": 24.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 9.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Wendell Carter Jr",
                                        "point": 17.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Wendell Carter Jr",
                                        "point": 17.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Jaren Jackson Jr",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Jaren Jackson Jr",
                                        "point": 26.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Franz Wagner",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Franz Wagner",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Desmond Bane",
                                        "point": 25.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -118,
                                        "description": "Desmond Bane",
                                        "point": 25.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -120,
                                        "description": "Jaylen Wells",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Jaylen Wells",
                                        "point": 11.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Zach Edey",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Zach Edey",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Santi Aldama",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Santi Aldama",
                                        "point": 16.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Cole Anthony",
                                        "point": 15.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Cole Anthony",
                                        "point": 15.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Paolo Banchero",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -118,
                                        "description": "Paolo Banchero",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "G.G. Jackson",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "G.G. Jackson",
                                        "point": 12.5
                                    }
                                ]
                            },
                            {
                                "key": "player_points_rebounds_assists",
                                "lastUpdate": "2025-02-21T18:43:35Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Ja Morant",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Ja Morant",
                                        "point": 31.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -130,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 10.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 100,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 10.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Desmond Bane",
                                        "point": 30.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -118,
                                        "description": "Desmond Bane",
                                        "point": 30.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Jaylen Wells",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Jaylen Wells",
                                        "point": 12.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Paolo Banchero",
                                        "point": 36.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Paolo Banchero",
                                        "point": 36.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Wendell Carter Jr",
                                        "point": 19.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Wendell Carter Jr",
                                        "point": 19.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Zach Edey",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Zach Edey",
                                        "point": 14.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Jaren Jackson Jr",
                                        "point": 28.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -110,
                                        "description": "Jaren Jackson Jr",
                                        "point": 28.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Santi Aldama",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Santi Aldama",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Cole Anthony",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Cole Anthony",
                                        "point": 18.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "G.G. Jackson",
                                        "point": 13.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "G.G. Jackson",
                                        "point": 13.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Franz Wagner",
                                        "point": 36.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -125,
                                        "description": "Franz Wagner",
                                        "point": 36.5
                                    }
                                ]
                            },
                            {
                                "key": "player_rebounds",
                                "lastUpdate": "2025-02-21T18:43:35Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": 110,
                                        "description": "Ja Morant",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -145,
                                        "description": "Ja Morant",
                                        "point": 4.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 120,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -160,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 125,
                                        "description": "Wendell Carter Jr",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -165,
                                        "description": "Wendell Carter Jr",
                                        "point": 8.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Jaren Jackson Jr",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Jaren Jackson Jr",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Franz Wagner",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Franz Wagner",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -130,
                                        "description": "Desmond Bane",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 100,
                                        "description": "Desmond Bane",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -160,
                                        "description": "Jaylen Wells",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 120,
                                        "description": "Jaylen Wells",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "Zach Edey",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -135,
                                        "description": "Zach Edey",
                                        "point": 7.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -140,
                                        "description": "Paolo Banchero",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 105,
                                        "description": "Paolo Banchero",
                                        "point": 6.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -135,
                                        "description": "Santi Aldama",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 100,
                                        "description": "Santi Aldama",
                                        "point": 5.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -115,
                                        "description": "Cole Anthony",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -115,
                                        "description": "Cole Anthony",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 100,
                                        "description": "G.G. Jackson",
                                        "point": 3.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -135,
                                        "description": "G.G. Jackson",
                                        "point": 3.5
                                    }
                                ]
                            },
                            {
                                "key": "player_threes",
                                "lastUpdate": "2025-02-21T18:43:35Z",
                                "outcomes": [
                                    {
                                        "name": "Over",
                                        "price": -105,
                                        "description": "Ja Morant",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -130,
                                        "description": "Ja Morant",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 160,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -220,
                                        "description": "Kentavious Caldwell-Pope",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -125,
                                        "description": "Wendell Carter Jr",
                                        "point": 0.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -105,
                                        "description": "Wendell Carter Jr",
                                        "point": 0.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 110,
                                        "description": "Jaren Jackson Jr",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -150,
                                        "description": "Jaren Jackson Jr",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -155,
                                        "description": "Franz Wagner",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 115,
                                        "description": "Franz Wagner",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 120,
                                        "description": "Desmond Bane",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -160,
                                        "description": "Desmond Bane",
                                        "point": 2.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 115,
                                        "description": "Jaylen Wells",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -150,
                                        "description": "Jaylen Wells",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 240,
                                        "description": "Zach Edey",
                                        "point": 0.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -325,
                                        "description": "Zach Edey",
                                        "point": 0.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -175,
                                        "description": "Paolo Banchero",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": 130,
                                        "description": "Paolo Banchero",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": -110,
                                        "description": "Santi Aldama",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -120,
                                        "description": "Santi Aldama",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 125,
                                        "description": "Cole Anthony",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -165,
                                        "description": "Cole Anthony",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Over",
                                        "price": 130,
                                        "description": "G.G. Jackson",
                                        "point": 1.5
                                    },
                                    {
                                        "name": "Under",
                                        "price": -175,
                                        "description": "G.G. Jackson",
                                        "point": 1.5
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "teamOptimalOddsMap": {
            "e2c5133f68dd32d234a6abcb91329cb4": [
                {
                    "bookmaker": "BetMGM",
                    "name": "Under",
                    "price": 100,
                    "betType": "player_points_rebounds_assists",
                    "point": 10.5,
                    "playerName": null
                },
                {
                    "bookmaker": "DraftKings",
                    "name": "Under",
                    "price": 130,
                    "betType": "player_rebounds",
                    "point": 2.5,
                    "playerName": null
                },
                {
                    "bookmaker": "DraftKings",
                    "name": "Under",
                    "price": -105,
                    "betType": "player_points_assists",
                    "point": 30.5,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Under",
                    "price": -102,
                    "betType": "player_points_rebounds",
                    "point": 11.5,
                    "playerName": null
                },
                {
                    "bookmaker": "BetMGM",
                    "name": "Under",
                    "price": 165,
                    "betType": "player_assists",
                    "point": 0.5,
                    "playerName": null
                },
                {
                    "bookmaker": "BetMGM",
                    "name": "Over",
                    "price": 105,
                    "betType": "player_points",
                    "point": 19.5,
                    "playerName": null
                },
                {
                    "bookmaker": "BetMGM",
                    "name": "Over",
                    "price": 100,
                    "betType": "player_points_assists",
                    "point": 7.5,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Under",
                    "price": 100,
                    "betType": "player_points",
                    "point": 18.5,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Over",
                    "price": 100,
                    "betType": "player_points_rebounds",
                    "point": 14.5,
                    "playerName": null
                },
                {
                    "bookmaker": "BetMGM",
                    "name": "Over",
                    "price": 135,
                    "betType": "player_assists",
                    "point": 1.5,
                    "playerName": null
                },
                {
                    "bookmaker": "DraftKings",
                    "name": "Over",
                    "price": -105,
                    "betType": "player_points_rebounds_assists",
                    "point": 29.5,
                    "playerName": null
                },
                {
                    "bookmaker": "DraftKings",
                    "name": "Over",
                    "price": 135,
                    "betType": "player_rebounds",
                    "point": 2.5,
                    "playerName": null
                },
                {
                    "bookmaker": "FanDuel",
                    "name": "Under",
                    "price": 134,
                    "betType": "player_threes",
                    "point": 1.5,
                    "playerName": null
                },
                {
                    "bookmaker": "BetMGM",
                    "name": "Over",
                    "price": 240,
                    "betType": "player_threes",
                    "point": 0.5,
                    "playerName": null
                }
            ]
        },
        "playerOptimalOddsMap": {
            "e2c5133f68dd32d234a6abcb91329cb4": {
                "Kentavious Caldwell-Pope": [
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -175,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -115,
                        "betType": "player_points_assists",
                        "point": 8.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 160,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -185,
                        "betType": "player_assists",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": 100,
                        "betType": "player_points",
                        "point": 7.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": 100,
                        "betType": "player_points_rebounds_assists",
                        "point": 10.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -115,
                        "betType": "player_points_assists",
                        "point": 8.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points_rebounds",
                        "point": 9.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -115,
                        "betType": "player_points",
                        "point": 7.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 135,
                        "betType": "player_rebounds",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -160,
                        "betType": "player_rebounds",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 135,
                        "betType": "player_assists",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -130,
                        "betType": "player_points_rebounds_assists",
                        "point": 10.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -115,
                        "betType": "player_points_rebounds",
                        "point": 9.5,
                        "playerName": null
                    }
                ],
                "Wendell Carter Jr": [
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -120,
                        "betType": "player_points_rebounds",
                        "point": 17.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -120,
                        "betType": "player_points_rebounds_assists",
                        "point": 19.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 125,
                        "betType": "player_rebounds",
                        "point": 8.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 110,
                        "betType": "player_rebounds",
                        "point": 7.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -120,
                        "betType": "player_assists",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_assists",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -118,
                        "betType": "player_points_assists",
                        "point": 11.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points_rebounds_assists",
                        "point": 19.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_threes",
                        "point": 0.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -125,
                        "betType": "player_threes",
                        "point": 0.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 100,
                        "betType": "player_points",
                        "point": 9.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_rebounds",
                        "point": 17.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": 100,
                        "betType": "player_points",
                        "point": 8.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_assists",
                        "point": 11.5,
                        "playerName": null
                    }
                ],
                "Desmond Bane": [
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -104,
                        "betType": "player_points_rebounds_assists",
                        "point": 29.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_assists",
                        "point": 23.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": 100,
                        "betType": "player_rebounds",
                        "point": 5.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -102,
                        "betType": "player_points_assists",
                        "point": 24.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 105,
                        "betType": "player_points",
                        "point": 19.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": 132,
                        "betType": "player_threes",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_rebounds",
                        "point": 24.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points_rebounds_assists",
                        "point": 30.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -108,
                        "betType": "player_points_rebounds",
                        "point": 24.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 114,
                        "betType": "player_assists",
                        "point": 5.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -115,
                        "betType": "player_rebounds",
                        "point": 5.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -154,
                        "betType": "player_threes",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": 100,
                        "betType": "player_points",
                        "point": 18.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": 112,
                        "betType": "player_assists",
                        "point": 4.5,
                        "playerName": null
                    }
                ],
                "Santi Aldama": [
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_rebounds",
                        "point": 16.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_rebounds_assists",
                        "point": 18.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": 115,
                        "betType": "player_assists",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -111,
                        "betType": "player_points",
                        "point": 10.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -104,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points_rebounds",
                        "point": 16.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -125,
                        "betType": "player_points_assists",
                        "point": 12.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 100,
                        "betType": "player_points",
                        "point": 11.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": 100,
                        "betType": "player_rebounds",
                        "point": 5.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_assists",
                        "point": 12.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -122,
                        "betType": "player_rebounds",
                        "point": 5.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -125,
                        "betType": "player_points_rebounds_assists",
                        "point": 18.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -155,
                        "betType": "player_assists",
                        "point": 1.5,
                        "playerName": null
                    }
                ],
                "Paolo Banchero": [
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 105,
                        "betType": "player_rebounds",
                        "point": 6.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points_assists",
                        "point": 29.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -118,
                        "betType": "player_points_rebounds",
                        "point": 31.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -106,
                        "betType": "player_points_rebounds",
                        "point": 31.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -120,
                        "betType": "player_points_rebounds_assists",
                        "point": 36.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 150,
                        "betType": "player_threes",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -132,
                        "betType": "player_rebounds",
                        "point": 6.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -102,
                        "betType": "player_points",
                        "point": 24.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": 102,
                        "betType": "player_assists",
                        "point": 5.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -120,
                        "betType": "player_assists",
                        "point": 5.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -118,
                        "betType": "player_points_assists",
                        "point": 29.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": 134,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points_rebounds_assists",
                        "point": 36.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -118,
                        "betType": "player_points",
                        "point": 24.5,
                        "playerName": null
                    }
                ],
                "G.G. Jackson": [
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 100,
                        "betType": "player_rebounds",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -175,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -120,
                        "betType": "player_points",
                        "point": 8.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -155,
                        "betType": "player_assists",
                        "point": 0.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -118,
                        "betType": "player_points_assists",
                        "point": 9.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": 115,
                        "betType": "player_assists",
                        "point": 0.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -135,
                        "betType": "player_rebounds",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 130,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -115,
                        "betType": "player_points_assists",
                        "point": 9.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_rebounds",
                        "point": 12.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points",
                        "point": 8.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -125,
                        "betType": "player_points_rebounds",
                        "point": 12.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_rebounds_assists",
                        "point": 13.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -130,
                        "betType": "player_points_rebounds_assists",
                        "point": 13.5,
                        "playerName": null
                    }
                ],
                "Zach Edey": [
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": 100,
                        "betType": "player_points",
                        "point": 6.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_assists",
                        "point": 0.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 240,
                        "betType": "player_threes",
                        "point": 0.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points",
                        "point": 6.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -130,
                        "betType": "player_rebounds",
                        "point": 7.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 100,
                        "betType": "player_points_assists",
                        "point": 7.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": 114,
                        "betType": "player_rebounds",
                        "point": 7.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -125,
                        "betType": "player_points_rebounds_assists",
                        "point": 14.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_rebounds_assists",
                        "point": 14.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -118,
                        "betType": "player_assists",
                        "point": 0.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -325,
                        "betType": "player_threes",
                        "point": 0.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -115,
                        "betType": "player_points_rebounds",
                        "point": 14.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -130,
                        "betType": "player_points_assists",
                        "point": 7.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": 100,
                        "betType": "player_points_rebounds",
                        "point": 14.5,
                        "playerName": null
                    }
                ],
                "Jaylen Wells": [
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -120,
                        "betType": "player_points_rebounds",
                        "point": 11.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 100,
                        "betType": "player_points",
                        "point": 8.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -145,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -220,
                        "betType": "player_assists",
                        "point": 0.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -120,
                        "betType": "player_points_assists",
                        "point": 9.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_assists",
                        "point": 9.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -115,
                        "betType": "player_points",
                        "point": 8.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -154,
                        "betType": "player_rebounds",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": 165,
                        "betType": "player_assists",
                        "point": 0.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -125,
                        "betType": "player_points_rebounds_assists",
                        "point": 12.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_rebounds_assists",
                        "point": 12.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -102,
                        "betType": "player_points_rebounds",
                        "point": 11.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 130,
                        "betType": "player_rebounds",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": 126,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    }
                ],
                "Cole Anthony": [
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -102,
                        "betType": "player_points",
                        "point": 11.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -102,
                        "betType": "player_points_rebounds_assists",
                        "point": 18.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_assists",
                        "point": 14.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -115,
                        "betType": "player_points_rebounds_assists",
                        "point": 18.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -140,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -106,
                        "betType": "player_points_assists",
                        "point": 15.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_rebounds",
                        "point": 16.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points",
                        "point": 12.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -115,
                        "betType": "player_points_rebounds",
                        "point": 15.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 125,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_rebounds",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -136,
                        "betType": "player_assists",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -102,
                        "betType": "player_rebounds",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 110,
                        "betType": "player_assists",
                        "point": 3.5,
                        "playerName": null
                    }
                ],
                "Ja Morant": [
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points_rebounds_assists",
                        "point": 31.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -113,
                        "betType": "player_points_assists",
                        "point": 27.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points_rebounds",
                        "point": 24.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 100,
                        "betType": "player_assists",
                        "point": 6.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_assists",
                        "point": 26.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -115,
                        "betType": "player_points",
                        "point": 20.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points",
                        "point": 19.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": 114,
                        "betType": "player_rebounds",
                        "point": 4.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -135,
                        "betType": "player_rebounds",
                        "point": 4.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -120,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -113,
                        "betType": "player_assists",
                        "point": 6.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -104,
                        "betType": "player_points_rebounds",
                        "point": 25.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -104,
                        "betType": "player_points_rebounds_assists",
                        "point": 31.5,
                        "playerName": null
                    }
                ],
                "Franz Wagner": [
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -108,
                        "betType": "player_points_assists",
                        "point": 30.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -154,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": 125,
                        "betType": "player_assists",
                        "point": 3.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points",
                        "point": 26.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -102,
                        "betType": "player_points",
                        "point": 25.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points_assists",
                        "point": 30.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -108,
                        "betType": "player_points_rebounds_assists",
                        "point": 35.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": 124,
                        "betType": "player_assists",
                        "point": 4.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_rebounds",
                        "point": 31.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -110,
                        "betType": "player_points_rebounds_assists",
                        "point": 36.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -130,
                        "betType": "player_rebounds",
                        "point": 5.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": 126,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": 114,
                        "betType": "player_rebounds",
                        "point": 5.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -113,
                        "betType": "player_points_rebounds",
                        "point": 31.5,
                        "playerName": null
                    }
                ],
                "Jaren Jackson Jr": [
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 110,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -122,
                        "betType": "player_rebounds",
                        "point": 5.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_rebounds_assists",
                        "point": 29.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": 105,
                        "betType": "player_rebounds",
                        "point": 5.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Over",
                        "price": -105,
                        "betType": "player_points_assists",
                        "point": 23.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": -115,
                        "betType": "player_points_rebounds",
                        "point": 26.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -105,
                        "betType": "player_points_assists",
                        "point": 22.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points",
                        "point": 20.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -104,
                        "betType": "player_points_rebounds",
                        "point": 26.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Over",
                        "price": 130,
                        "betType": "player_assists",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "BetMGM",
                        "name": "Under",
                        "price": -110,
                        "betType": "player_points_rebounds_assists",
                        "point": 28.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "DraftKings",
                        "name": "Under",
                        "price": -140,
                        "betType": "player_assists",
                        "point": 2.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Under",
                        "price": -122,
                        "betType": "player_threes",
                        "point": 1.5,
                        "playerName": null
                    },
                    {
                        "bookmaker": "FanDuel",
                        "name": "Over",
                        "price": -102,
                        "betType": "player_points",
                        "point": 21.5,
                        "playerName": null
                    }
                ]
            }
        }
    }
};


export const nbaLiveScoresResponse = {
    "isError": false,
    "errorMessage": null,
    "data": {
        "get": "games/",
        "parameters": {
            "live": "all"
        },
        "errors": [],
        "results": 1,
        "response": [
            {
                "id": 15364,
                "league": "standard",
                "season": 2024,
                "date": {
                    "start": "2025-04-22T02:00:00.000Z",
                    "end": null,
                    "duration": null
                },
                "stage": 3,
                "status": {
                    "clock": "10:28",
                    "halftime": false,
                    "short": 2,
                    "long": "In Play"
                },
                "periods": {
                    "current": 3,
                    "total": 4,
                    "endOfPeriod": false
                },
                "arena": {
                    "name": "Ball Arena",
                    "city": "Denver",
                    "state": "CO",
                    "country": null
                },
                "teams": {
                    "visitors": {
                        "id": 24,
                        "name": "New York Knicks",
                        "nickname": "Knicks",
                        "code": "NYK",
                        "logo": ""
                    },
                    "home": {
                        "id": 9,
                        "name": "Cleveland Cavaliers",
                        "nickname": "Cavaliers",
                        "code": "CLE",
                        "logo": ""
                    }
                },
                "scores": {
                    "visitors": {
                        "win": 0,
                        "loss": 0,
                        "series": {
                            "win": 0,
                            "loss": 0
                        },
                        "linescore": [
                            "25",
                            "30",
                            "0",
                            ""
                        ],
                        "points": 55
                    },
                    "home": {
                        "win": 0,
                        "loss": 0,
                        "series": {
                            "win": 0,
                            "loss": 0
                        },
                        "linescore": [
                            "31",
                            "21",
                            "4",
                            ""
                        ],
                        "points": 56
                    }
                },
                "officials": [],
                "timesTied": null,
                "leadChanges": null,
                "nugget": null
            },
            {
                "id": 15364,
                "league": "standard",
                "season": 2024,
                "date": {
                    "start": "2025-04-22T02:00:00.000Z",
                    "end": null,
                    "duration": null
                },
                "stage": 3,
                "status": {
                    "clock": "10:28",
                    "halftime": false,
                    "short": 2,
                    "long": "In Play"
                },
                "periods": {
                    "current": 3,
                    "total": 4,
                    "endOfPeriod": false
                },
                "arena": {
                    "name": "Ball Arena",
                    "city": "Denver",
                    "state": "CO",
                    "country": null
                },
                "teams": {
                    "visitors": {
                        "id": 19,
                        "name": "Memphis Grizzlies",
                        "nickname": "Grizzlies",
                        "code": "MEM",
                        "logo": ""
                    },
                    "home": {
                        "id": 26,
                        "name": "Orlando Magic",
                        "nickname": "Magic",
                        "code": "ORL",
                        "logo": ""
                    }
                },
                "scores": {
                    "visitors": {
                        "win": 0,
                        "loss": 0,
                        "series": {
                            "win": 0,
                            "loss": 0
                        },
                        "linescore": [
                            "25",
                            "30",
                            "0",
                            ""
                        ],
                        "points": 55
                    },
                    "home": {
                        "win": 0,
                        "loss": 0,
                        "series": {
                            "win": 0,
                            "loss": 0
                        },
                        "linescore": [
                            "31",
                            "21",
                            "4",
                            ""
                        ],
                        "points": 56
                    }
                },
                "officials": [],
                "timesTied": null,
                "leadChanges": null,
                "nugget": null
            }
        ]
    },
    "cachedDateTime": "2025-04-22T03:29:00.987481Z"
}